import { Component, Input, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { initItemsInvoiceParams, NovaPoshtaService } from '../../services/nova-poshta.service';
import { IParams } from '../../model/http';
import { map, Observable, Subject, take, takeUntil } from 'rxjs';
import { AppTableSource, ColumnSortType } from '../../model/table.model';
import { NotificationService } from '../../services/notifications.service';
import { IntegrationService } from '../../services/integration.service';
import { BaseService } from '../../services/base.service';
import { tableHeaders } from './tab-invoices.interface';

@Component({
  selector: 'app-tab-invoices',
  templateUrl: './tab-invoices.component.html',
  styleUrls: ['./tab-invoices.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TabInvoicesComponent implements OnInit, OnDestroy {
  private readonly destroy$: Subject<null> = new Subject<null>();

  @Input() apiKey!: any;

  dataSource$: Observable<AppTableSource> = this.novaPoshtaService.itemsMyInvoices$.pipe(
    map((v) => {
      tableHeaders.map((column) => {
        column.sort = ColumnSortType.NONE;
        if (column.value === this.dataSort?.active) {
          column.sort = this.dataSort.direction;
        }
        return column;
      });

      return {
        headers: tableHeaders,
        rows: v.data,
        pageSize: v?.pageSize || 0,
        pageIndex: v.pageIndex ? v.pageIndex - 1 : 0,
        length: v.totalCount || 0,
      };
    }),
  );
  visibleColumns = tableHeaders.map((v) => v.value);

  // Variables

  private itemsRequest: any;
  private dataSort: any;
  public isLoader: boolean = false;
  private timerSearch: any;

  constructor(
    private readonly notificationService: NotificationService,
    private readonly integrationService: IntegrationService,
    private readonly novaPoshtaService: NovaPoshtaService,
    public readonly baseService: BaseService,
  ) {}

  getItemsWithUpdatedParams(params: IParams, isLoader = false) {
    if (this.itemsRequest) {
      this.itemsRequest.unsubscribe();
    }
    this.isLoader = isLoader;
    this.itemsRequest = this.novaPoshtaService
      .setQueryListInvoicesParams(params)
      .pipe(takeUntil(this.destroy$), take(1))
      .subscribe({
        next: (res) => {
          this.isLoader = false;
        },
        error: () => {
          this.isLoader = false;
        },
      });
  }

  ngOnInit() {
    this.isLoader = true;
    this.novaPoshtaService
      .loadListMyInvoices(this.apiKey)
      .pipe(takeUntil(this.destroy$), take(1))
      .subscribe({
        next: () => {
          this.isLoader = false;
        },
        error: () => {
          this.isLoader = false;
        },
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  onSortChange(sortState: any) {
    this.novaPoshtaService.changeMyInvoicesSort(sortState);
  }

  onPaginationChange(paginationDetails: {
    previousPageIndex: number;
    pageIndex: number;
    pageSize: number;
    length: number;
  }): void {
    this.novaPoshtaService.changeMyInvoicesPagination(paginationDetails);
  }

  onActionChange(event: any) {
    if (event.label === 'DELETE') {
    }
    if (event.label === 'ADD_TRACKER') {
    }
  }

  onSearchChange(search: string) {
    this.novaPoshtaService.searchMyInvoices(search);
  }
}
